import Login from "./components/auth/Login.js";
import Register from "./components/auth/Register.js";

import Sculc from "./components/sculc/Sculc.js";
import SubmitAbstract from "./components/sculc/SubmitAbstract.js"
import Home from "./components/home/Home.js"
import Navbar from "./components/navbar/Navbar.js"
import Footer from "./components/footer/Footer.js"
import Profile from "./components/profile/Profile.js"
import Board from './components/board/Board.js'
import Naclo from './components/naclo/Naclo.js'
import EditProfile from "./components/profile/EditProfile.js";

import CongratulationsPage from "./components/sculc/CongratulationsPage.js";
import ViewSubmission from "./components/sculc/ViewSubmission.js";
import CompleteProfile from "./components/auth/CompleteProfile.js";
import UserData from "./components/admin/UserData.js"

import Sculc2025 from './components/sculc/sculc-2025/Sculc2025.js';

import Sculc2024 from './components/sculc/Sculc-2024/Sculc2024.js';

import Sculc2023 from './components/sculc/sculc-2023/Sculc2023.js';
import Sculc2023Program from './components/sculc/sculc-2023/Sculc2023-program.js';
import Sculc2023Schedule from './components/sculc/sculc-2023/Sculc2023-schedule.js';
import Sculc2023Presentation from './components/sculc/sculc-2023/Sculc2023-presentation.js';
import Sculc2023Photo from './components/sculc/sculc-2023/Sculc2023-photo.js';

import Sculc2022 from './components/sculc/sculc-2022/Sculc-2022.js'
import Sculc2022Program from './components/sculc/sculc-2022/Sculc-2022-program.js'
import Sculc2022Presentation from './components/sculc/sculc-2022/Sculc-2022-presentation.js'
import Sculc2022Photo from './components/sculc/sculc-2022/Sculc-2022-photo.js'

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { getFirestoreData } from "./firebase/Firestore.js";
import ProtectedRoute from "./components/routes/ProtectedRoute.js";

import { auth } from './firebase/firebase.js';
import { useEffect } from "react";
import { useAuth, AuthProvider } from "./contexts/AuthContext.js";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Sculc2026 from "./components/sculc/sculc-2026/Sculc2026.js";
import Lingua from "./components/LinguA/Lingua.js";
function App() {
    const location = useLocation();


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        console.log("User info:", user);
      } else {
        console.log("No user is signed in.");
      }
    });

    // Clean up the subscription on unmount
    return () => unsubscribe();
  }, []);

    const theme = createTheme({
      palette: {
        primary: {
          main: '#1e6c93'
        }
      }
    });

  return (
    <AuthProvider>
       <ThemeProvider theme={theme}>
      <div className="App">
              <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/sculc-2027" element={<Sculc />} />
          <Route path="/sculc-2026" element={<Sculc2026 />} />
          <Route path="/home" element={<Home />} />
          <Route path="/board" element={<Board />} />
          <Route path="/naclo" element={<Naclo />} />
          <Route path="/lingua" element={<Lingua />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />
          <Route path="/sculc-2022" element={<Sculc2022 />} />
          <Route path="/sculc-2022-program" element={<Sculc2022Program />} />
          <Route path="/sculc-2022-presentation" element={<Sculc2022Presentation />} />
          <Route path="/sculc-2022-photo" element={<Sculc2022Photo /> } />
          <Route path="/sculc/submit-abstract" element={<ProtectedRoute message="You Must Log In to Submit an Abstract" redirectTo="/login"><SubmitAbstract /></ProtectedRoute>}/>
          <Route path="/sculc/view-submission" element={<ViewSubmission />} />
          <Route path="/sculc/congratulations-page" element={<CongratulationsPage />} />
          <Route path="/user-data" element={<ProtectedRoute requireAdmin={true} message="Unauthorized access" redirectTo="/login"><UserData /></ProtectedRoute>} />
          <Route path="/sculc-2025" element={<Sculc2025 />} /> 
          <Route path="/sculc-2024" element={<Sculc2024 />} /> 
                  <Route path="/sculc-2023" element={<Sculc2023 />} /> 
                  <Route path="/sculc-2023-program" element={<Sculc2023Program />} /> 
                  <Route path="/sculc-2023-schedule" element={<Sculc2023Schedule />} /> 
                  <Route path="/sculc-2023-presentation" element={<Sculc2023Presentation/>} /> 
                  <Route path="/sculc-2023-photo" element={<Sculc2023Photo />} /> 
        </Routes>
        <Footer />
      </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;